// apps/web/src/services/endpoints.ts
// Centralized API endpoint constants for the web app. Use these so strings are updated in one place.
export const API_ROOT = import.meta.env.VITE_API_URL ?? 'http://localhost:3000/api'

// Paths (relative to API_ROOT when used from the browser client)
export const PATHS = {
	auth: {
		otpStart: '/auth/otp/start',
		otpVerify: '/auth/otp/verify',
		logout: '/auth/logout',
		google: '/auth/google',
	},
	counselor: '/counselor',
	parent: '/parent',
	file: '/file',
	recaptcha: '/recaptcha',
}

// Full endpoints where we sometimes need the complete URL (useful in tests or when building absolute URLs)
export const ENDPOINTS = {
	auth: {
		otpStart: `${API_ROOT}${PATHS.auth.otpStart}`,
		otpVerify: `${API_ROOT}${PATHS.auth.otpVerify}`,
		logout: `${API_ROOT}${PATHS.auth.logout}`,
		google: `${API_ROOT}${PATHS.auth.google}`,
	},
	counselor: `${API_ROOT}${PATHS.counselor}`,
	parent: `${API_ROOT}${PATHS.parent}`,
	file: `${API_ROOT}${PATHS.file}`,
	recaptcha: `${API_ROOT}${PATHS.recaptcha}`,
}

export default ENDPOINTS
